
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const LipotropicInjections = () => {
  const treatmentData = {
    title: "Lipotropic Injections",
    subtitle: "Fat-burning injections for enhanced metabolism and energy",
    description: "Lipotropic injections contain essential amino acids, vitamins, and minerals that help boost metabolism, burn fat, and increase energy levels naturally.",
    whoItsFor: [
      "Those looking to boost metabolism",
      "People wanting to enhance weight loss efforts",
      "Anyone seeking increased energy levels",
      "Clients with sluggish metabolism",
      "Those wanting wellness support"
    ],
    packages: [
      {
        name: "Single Injection",
        visitorPrice: "$75",
        memberPrice: "$68",
        description: "One lipotropic injection treatment"
      },
      {
        name: "Weekly Series",
        visitorPrice: "$250",
        memberPrice: "$225",
        description: "Package of 4 weekly injections"
      },
      {
        name: "Monthly Plan",
        visitorPrice: "$200",
        memberPrice: "$180",
        description: "Monthly subscription for ongoing support"
      }
    ],
    beforeCare: [
      "Eat a light meal before treatment",
      "Stay hydrated",
      "Wear clothing that allows easy access to injection site",
      "Inform us of any allergies"
    ],
    duringCare: [
      "Quick intramuscular injection",
      "Precise dosing for optimal results",
      "5-10 minute treatment time",
      "Minimal discomfort"
    ],
    afterCare: [
      "Stay hydrated for 24 hours",
      "Eat a balanced diet",
      "Exercise as tolerated",
      "Effects typically felt within 24-48 hours"
    ],
    memberPerks: [
      "10% discount on lipotropic packages",
      "Complimentary wellness consultation",
      "Priority booking for weekly series",
      "Free B12 add-on with series packages",
      "Access to nutrition guidance and support"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default LipotropicInjections;
